import { render, staticRenderFns } from "./Axeptio.vue?vue&type=template&id=4136c89d"
import script from "./Axeptio.vue?vue&type=script&lang=js"
export * from "./Axeptio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports